import React, { useEffect, useState, useRef } from 'react'
import Bread from '../components/Breadcrumb'
import { ETokenByWechat, EWechatQRCode, LoginBread, NPersonal } from '../../models/constants'
import { Form, Input, Button } from 'antd'
import { Link } from 'react-router-dom'

import { effect, useStore } from '../../dva16'
import { NUser, EPostLogin, EGetWechatCode, EGetLoginStatus } from '../../models/constants'

import './index.less'

function onFinish(values) {
  effect(NUser, EPostLogin, values)
}

function CreateWeChatLogin({ setIsGetchatCode }) {
  const { qrcode } = useStore(NPersonal)
  const interval = useRef(null)

  useEffect(() => {
    effect(NPersonal, EWechatQRCode)
    console.log('1')
    return () => {
      console.log(2)
    }
  }, [])
  useEffect(() => {
    clearInterval(interval.current)
    interval.current = setInterval(() => {
      if (qrcode && qrcode.code) {
        effect(NPersonal, ETokenByWechat, { code: qrcode.code })
      }
    }, 1000)
    return () => {
      clearInterval(interval.current)
    }
  }, [qrcode])

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      {qrcode && (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <img style={{ width: 190, height: 190, paddingBottom: 12 }} src={qrcode.url} alt="QRCode"></img>
          <span style={{ fontSize: 16 }}>请打开微信扫码</span>
        </div>
      )}
      <div className="loginfoot">
        <div
          className="weChart"
          onClick={() => {
            setIsGetchatCode(true)
          }}
        >
          <span>手机登录</span>
        </div>
        <div className="other">
          <Link to="/register/0">立即注册</Link>
          <span>|</span>
          <Link to="/register/1">忘记密码？</Link>
        </div>
      </div>
    </div>
  )
}

function Regist() {
  // const { isGetchatCode, wechatCode } = useStore(NUser)
  const [isGetchatCode, setIsGetchatCode] = useState(false)

  const [form] = Form.useForm()
  // const [isPhoneLogin, setIsPhoneLogin] = useState(true)

  function wechatStatus(tagTime) {
    let index = tagTime
    // let timer = setInterval(()=>{
    // effect(NUser, EGetLoginStatus, { code: wechatCode })
    //   this.props.dispatch({
    //     type: 'user/ApiGetLoginStatus',
    //     payload: {
    //       code: this.state.code
    //     }
    //   })
    //   index -= 2
    //   let href = window.location.href.split('#')[1]
    //   if((href !== '/login') || (this.state.whichKey === '1') || index < 0){
    //     clearInterval(timer)
    //   }
    // },2000)
  }

  const createPhoneLogin = () => {
    return (
      <Form form={form} name="phone" onFinish={onFinish}>
        <Form.Item
          name="phone"
          rules={[
            {
              required: true,
              message: '请输入手机号',
            },
          ]}
        >
          <Input size="large" placeholder="手机号" />
        </Form.Item>

        <Form.Item
          name="password"
          rules={[
            {
              required: true,
              message: '请输入密码',
            },
          ]}
        >
          <Input.Password size="large" visibilityToggle={false} placeholder="密码" />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" className="button">
            登录
          </Button>
          <div className="loginfoot">
            <div
              className="weChart"
              onClick={() => {
                setIsGetchatCode(false)
              }}
            >
              <span>微信登录</span>
            </div>
            <div className="other">
              <Link to="/register/0">立即注册</Link>
              <span>|</span>
              <Link to="/register/1">忘记密码？</Link>
            </div>
          </div>
        </Form.Item>
      </Form>
    )
  }
  return (
    <div id="login">
      <div className="from">
        {Bread(LoginBread)}
        <div className="fromlist">
          <img src={require('../static/logo.jpg')} alt="" />
          <p>帝业论坛登录</p>
          <div className="center">
            {/* 根据isGetchatCode判断是微信登录还是手机登录true为手机登录false为微信登录 */}

            {isGetchatCode ? createPhoneLogin() : <CreateWeChatLogin setIsGetchatCode={setIsGetchatCode} />}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Regist
